import { render, staticRenderFns } from "./ProductSelectedSummary.vue?vue&type=template&id=6b04af3e&scoped=true"
import script from "./ProductSelectedSummary.vue?vue&type=script&lang=js"
export * from "./ProductSelectedSummary.vue?vue&type=script&lang=js"
import style0 from "./ProductSelectedSummary.vue?vue&type=style&index=0&id=6b04af3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b04af3e",
  null
  
)

export default component.exports